import { Show } from "solid-js";
import Pill from "../../pill/Pill";
import Text from "../../text/Text";
import type { DynamicValueOption, ListItemHtmlProps } from "../../../types/Menu";
import ListItemContainer from "./ListItemContainer";
import { DynamicValueIconTile } from "../../icon/IconTile";

type DynamicValueListItemProps = Omit<DynamicValueOption<null>, "id" | "variant" | "value"> & {
  htmlProps: ListItemHtmlProps | null;
};

const DynamicValueListItem = (props: DynamicValueListItemProps) => (
  <ListItemContainer htmlProps={props.htmlProps} disabled={props.disabled} hidden={props.hidden} type="row">
    <div class="flex w-full min-w-0 items-center gap-x-1.5">
      <Show when={props.icon}>
        {(icon) => <DynamicValueIconTile icon={icon().name} size="sm" iconClassList={{ [icon().class]: true }} />}
      </Show>
      <Text as="span" truncate text={props.label} class="text-base-regular text-primary group-disabled:text-disabled" />
    </div>

    <Show when={props.pill}>{(pill) => <Pill variant="neutral" label={pill()} />}</Show>
  </ListItemContainer>
);

export default DynamicValueListItem;
